<template>
    <section class="slogan__container" v-if="fields">
      <div class="container" data-animate-group>
        <div class="left-content" data-animate="slideUp">
          <p>{{ fields['Left text'] }}</p>
        </div>
        <div class="right-content" data-animate="slideUp">
          <p>
            {{ fields['Right text'] }}
          </p>
        </div>
    </div>
  </section>
  </template>
  
  <script>
  export default {
    props: {
          fields: [Array,Object],
        },
  };
  </script>
    
    <style scoped>
    .container {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      gap: 84px;
      font-family: Arial, sans-serif;
    }
    .slogan__container.left .left-content{
      order: 2;
      align-items: end;
    }
    .left-content {
      flex: 1;
      display: flex;
      text-align: left;
      flex-direction: column;
      justify-content: space-between;
      max-width: 25.5%;
    }
    
    .left-content p {
      color: rgb(5, 5, 5);
      font-size: 16px;
      font-weight: 400;
      line-height: 140%;
      letter-spacing: 0%;
      text-align: left;
      max-width: 321px;
    }
    
    .icons {
      display: flex;
      gap: 10px;
    }
    
    .icon-button {
      border: none;
      background: none;
      cursor: pointer;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: rgb(222, 230, 234);
    }
    
    .icon-button img {
      width: 20px;
      height: 20px;
    }
    
    .right-content {
      flex: 1;
      max-width: 58%;
      text-align: left;
    }
    
    .right-content h2 {
      font-size: 24px;
      margin-bottom: 15px;
      color: #000;
    }
    .right-content,.left-content{
    }
    .right-content p {
      /* Header/H2: 32px Medium */
      color: rgb(5, 5, 5);
      font-size: 32px;
      font-weight: 500;
      line-height: 140%;
      letter-spacing: 0%;
      text-align: left;
    }
    
    .footer {
      display: flex;
      justify-content: space-between;
      color: rgb(5, 5, 5);
      font-family: Satoshi;
      font-size: 16px;
      font-weight: 500;
      line-height: 140%;
      letter-spacing: 0%;
      text-align: left;
      max-width: 409px;
    }
    @media (max-width: 1024px) {
      .container{
        gap: 22px;
      }
      .right-content{
        width: 66%;
      }
      .right-content p{
        font-size: 24px;
      }
      .left-content{
        max-width: 35.5%;
      }
    }
    /* Адаптивность */
    @media (max-width: 768px) {
      .container {
          flex-direction: column;
          gap: 24px;
      }
      .right-content p{
        font-size: 20px;
      }
      .right-content,.left-content{
          width: 100%;
          max-width: 100%;
      }
      .left-content{
          order: 2;
      }
      .left-content p{
          padding-bottom: 24px;
          max-width: 100%;
          font-size: 18px;
      }
      .slogan__container{
        padding-bottom: 100px;
      }
      .slogan__container.left .left-content{
      order: 2;
      align-items: unset;
    }
    }
    </style>
    